import { getIn } from 'formik';
import React from 'react';

import { WipConfig } from '../../types';
import {
  CreditAgreement,
  isPropertyContainerType,
  isPropertyType,
} from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { Property } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/Property';
import { PropertyContainer } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/PropertyContainer';

export const PropertyView: React.FC<{
  headers: (
    | keyof CreditAgreement.DomainEntity.Property
    | keyof CreditAgreement.DomainEntity.PropertyContainer
  )[];
  basePropertyKey: string;
  property:
    | CreditAgreement.DomainEntity.PropertyContainer
    | CreditAgreement.DomainEntity.Property;
  propertyKey: string;
  wipConfig?: WipConfig;
  idx?: number;
}> = ({ headers, property, propertyKey, wipConfig, basePropertyKey, idx }) => {
  if (!property) return null;

  if (isPropertyContainerType(property.type)) {
    return (
      <PropertyContainer
        headers={headers}
        basePropertyKey={basePropertyKey}
        propertyKey={propertyKey}
        // @ts-ignore
        property={property}
        wipConfig={wipConfig}
        isOptional={
          !!(
            wipConfig &&
            !getIn(wipConfig.wipShell, `${basePropertyKey}.${propertyKey}`)
          )
        }
      />
    );
  }
  if (isPropertyType(property.type)) {
    return (
      <Property
        headers={headers}
        basePropertyKey={basePropertyKey}
        propertyKey={propertyKey}
        // @ts-ignore
        property={property}
        wipConfig={wipConfig}
        isOptional={
          !!(
            wipConfig &&
            !getIn(wipConfig.wipShell, `${basePropertyKey}.${propertyKey}`)
          )
        }
        idx={idx}
      />
    );
  }
  throw Error(`Expected to receive a valid property or property container`);
};
